import { EventCardHome } from 'shared/components/eventCardHome';
import { HotBannerData } from 'shared/types/cms';
import { getParticipants } from 'shared/util/utility';

interface HotLiveBannerCardProps {
	data: HotBannerData;
}

const HotLiveBannerCard = ({ data }: HotLiveBannerCardProps) => {
	if (!data || !data.eventGame) {
		return null;
	}

	const { eventGame } = data;

	return (
		<EventCardHome
			key={`hotbanner-events-${eventGame.eventId}`}
			categoryId={eventGame.categoryId}
			eventStart={eventGame.eventStart}
			gamesCount={eventGame.gamesCount}
			sportID={eventGame.sportId}
			isLive
			infos={eventGame.infos}
			parentId={eventGame.parentId}
			participants={getParticipants(eventGame)}
			event={eventGame}
			sportEventImg={data.imageUrl}
		/>
	);
};

export default HotLiveBannerCard;
